import { Pues } from './pues';
import getHtmlParam from '../../utilities/htmlParam';

let param = getHtmlParam('.js-param .param');

export class Advisor {
  campagne() {
    const advisorContainer = document.querySelector('.result-assistent');

    if (!advisorContainer) return;

    let prevParam: HTMLInputElement;

    advisorContainer.addEventListener('click', (e) => {
      const target = e.target as HTMLElement;
      const step = document.querySelector('.assistent-step');
      const featuresChecked = document.querySelectorAll('.filter-form-wrapper .form-field-input-checkbox:checked');
      const filterForm = document.getElementById('filter-form') as HTMLFormElement;
      const currentStep = advisorContainer.querySelector('[name="acQuestionId"]');
      const advisorId = advisorContainer.querySelector('[name="acId"]');

      if (target.classList.contains('next-step') || target.classList.contains('skip-step')) {
        const filterCurrentStep = filterForm.querySelector('[name="acQuestionId"]');
        const filterAdvisorId = filterForm.querySelector('[name="acId"]');
        filterCurrentStep && filterCurrentStep.parentNode.removeChild(filterCurrentStep);
        filterAdvisorId && filterAdvisorId.parentNode.removeChild(filterAdvisorId);
        prevParam = document.createElement('input');
        prevParam.type = 'hidden';
        prevParam.name = 'acStep';
      }

      if (target.classList.contains('next-step')) {
        updateSessionStorage('next');
        const selected = step.querySelectorAll('input:checked');
        prevParam.value = 'next';
        filterForm.appendChild(prevParam);

        currentStep && filterForm.appendChild(currentStep);
        advisorId && filterForm.appendChild(advisorId);

        // if no selected features, trigger update call
        if (!selected.length) {
          new Pues().filterProducts(filterForm, '1', false, true);
          return;
        }

        // check if question is type category
        const firstFeature = selected[0].parentElement.querySelector('.answer-filters') as HTMLElement;
        const type = firstFeature && firstFeature.dataset.type;
        const mainUrl = firstFeature && firstFeature.dataset.mainurl;

        if (mainUrl && mainUrl.length > 10) {
          window.location.href = param.get('urlPrefix') + mainUrl;
          return;
        }

        if (type === 'category') {
          const filterWrapper = document.getElementById('filter-form');
          if (filterWrapper) {
            const categoryPath = filterWrapper.querySelector('input[value="categoryPath"]') as HTMLInputElement;
            if (categoryPath) {
              const categoryPathIndex = categoryPath.name.substring(0, 11);
              const categoryPaths = filterWrapper.querySelectorAll('[name^="' + categoryPathIndex + '"]');
              categoryPaths.forEach((category) => {
                category.parentNode.removeChild(category);
              });
            }

            const categoryPathFilters = filterWrapper.querySelectorAll('[data-filter-name="categoryPath"]');
            categoryPathFilters.forEach((filter: HTMLInputElement) => filter.checked = false);

            for (let i = 0; i < selected.length; i++) {
              const answerId = selected[i].previousElementSibling as HTMLInputElement;
              if (answerId && answerId.name === 'acAnswerId') {
                filterForm.appendChild(selected[i].previousElementSibling);
              }
            }

            const pathInput = document.createElement('input');
            pathInput.type = 'hidden';
            pathInput.name = 'filters[1].name';
            pathInput.value = 'categoryPath';
            filterWrapper.appendChild(pathInput);
            const categoryInput = pathInput.cloneNode(true) as HTMLInputElement;
            categoryInput.name = 'filters[1].value';
            categoryInput.value = firstFeature.dataset.value;
            filterWrapper.appendChild(categoryInput);

            new Pues().filterProducts(filterForm, '1', false, true);
          }
          return;
        }

        // check all selected features and trigger update call at the end
        for (let i = 0; i < selected.length; i++) {
          const answerId = selected[i].previousElementSibling as HTMLInputElement;
          if (answerId && answerId.name === 'acAnswerId') {
            filterForm.appendChild(selected[i].previousElementSibling);
          }

          const features = selected[i].parentElement.querySelectorAll('.answer-filters');
          let filter: HTMLInputElement;
          features.forEach((feature: HTMLElement) => {
            const type = feature.dataset.type;
            const featureId = feature.dataset.item;
            const value = feature.dataset.value;
            if (type === 'brand') {
              filter = value && document.querySelector('.form-field-input-checkbox[data-filter-name="' + type + '"][value="' + value + '"]') as HTMLInputElement;
            } else {
              filter = value && document.querySelector('.form-field-input-checkbox[data-filter-id="' + featureId + '"][value="' + value + '"]') as HTMLInputElement;
            }
            filter && (filter.checked = true);
          });
          if (selected.length - 1 === i || selected.length === 1) {
            new Pues().filterProducts(filterForm, '1', false, true);
          }
        }

      }
      if (target.classList.contains('prev-step')) {
        updateSessionStorage('prev');
      }
      if (target.classList.contains('skip-step')) {
        updateSessionStorage('next');
        prevParam.value = 'skip';
        filterForm.appendChild(prevParam);
        currentStep && filterForm.appendChild(currentStep);
        advisorId && filterForm.appendChild(advisorId);

        new Pues().filterProducts(filterForm, '1', false, true);
      }

      if (target.closest('.answer-group')) {
        const nextBtn = advisorContainer.querySelector('.next-step') as HTMLButtonElement;
        nextBtn && nextBtn.removeAttribute('disabled');
      }
    });
  }

}

function updateSessionStorage(direction: string) {
  let advisorHistory = [];
  let lastElement;
  let storage = sessionStorage.getItem('advisor-history');
  if (storage) {
    advisorHistory = JSON.parse(storage);
  }
  if (direction === 'next') {
    advisorHistory.push(window.location.href);
  }
  if (storage && direction === 'prev') {
    lastElement = advisorHistory.pop();
  }
  sessionStorage.setItem('advisor-history', JSON.stringify(advisorHistory));

  if (lastElement && direction === 'prev') {
    window.location.href = lastElement;
  }
}

export function updateAdvisorStep(newAdvisorContainer: NodeList | any) {
  const advisorContainer = document.querySelector('.result-assistent') as HTMLElement;
  if (!advisorContainer) return;

  const advisor = advisorContainer.querySelector('.advisor-box');
  const finishContainer = newAdvisorContainer && newAdvisorContainer.querySelector('.advisor-completed');

  if (finishContainer) {
    advisor.parentNode.replaceChild(finishContainer, advisor);
    sessionStorage.removeItem('advisor-history');
    return;
  }

  if (newAdvisorContainer && (newAdvisorContainer.childNodes.length > 1)) {
    advisor && advisor.parentNode.replaceChild(newAdvisorContainer.querySelector('.advisor-box'), advisor);
  }
}
